export type Coordinates = readonly [lng: number, lat: number];

type Location = {
  lat: number;
  lng: number;
};

export const distanceKm = (
  [lng1, lat1]: Coordinates,
  [lng2, lat2]: Coordinates,
) => {
  const earthRadiusKm = 6371;
  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;
  const latitudeDifference = toRadians(lat2 - lat1);
  const longitudeDifference = toRadians(lng2 - lng1);
  const calculation =
    Math.sin(latitudeDifference / 2) ** 2 +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(longitudeDifference / 2) ** 2;

  return 2 * earthRadiusKm * Math.asin(Math.sqrt(calculation));
};

export const findNearestLocations = <T extends Location>({
  locations,
  origin,
}: {
  locations: T[];
  origin: Coordinates;
}) =>
  locations
    .map(location => ({
      ...location,
      distance: distanceKm(origin, [location.lng, location.lat]),
    }))
    .sort((first, second) => first.distance - second.distance);
